import $ from 'jquery';
import ko from 'knockout';
import 'autoresize-textarea';

ko.bindingHandlers.textareaAutoResize = {

  init: function (element) {
    $(element).autoResize();
  }
};
